module.exports = __webpack_public_path__ + "img/testpreview.e6775d0b.svg";